import React, { useMemo, useState } from "react";
import moment from "moment";
import classNames from "classnames";
//import GridWrapper from "../../../../components/GridWrapper";
import { FormLabel } from "../../../components/forms";
import { CurrencyInput, DateInput, FormInput } from "../../../components/forms";
import styled from "styled-components";
import { Button } from "../../../components";
import { ErrorMessage, ErrorMessageWrapper } from "../../../components/messages";
import { ThemedIcon, Main, PageSubHeader, FiltersAppliedWarningMessage } from "../../../components/utilities";
import AgedDebtorsAgedMonthBreakdownModal from "./AgedDebtorsAgedMonthBreakdownModal";
import ArchiveDebtorsModal from "./ArchiveDebtorsModal";
import { useGetAgedDebtors } from "../hooks/useGetAgedDebtors"
import useArchiveDebtors from "../hooks/useArchiveDebtors";
import { useAgedDebtorsProvider } from "../../../hooks/AgedDebtorsContext";
import { useAdministrationFeesProvider } from "../../../hooks/AdministrationFeesContext";


export const testExport = "will it work?";

export const GridItem = ({ className, data, openModal, ...rest }) => {
    const { agedMonth, archiveMonth, totalDebit, feeGroupIds } = data;
    return (
        <div 
            className={classNames(className, "d-flex justify-content-end border has-pointer")} 
            onClick={() => openModal({agedMonth,archiveMonth,totalDebit, feeGroupIds})} {...rest}
        >
            {totalDebit === "" && (<span>&nbsp;</span>)}
            {totalDebit !== "" && (<CurrencyInput displayType="text" value={totalDebit} />)}
        </div>
    );
};

export const GridTotalItem = ( {className, data} ) => {
    const {archiveMonth, totalDebit } = data;
    return (
        <div 
            className={classNames(className, "d-flex justify-content-end border has-pointer")} 
        >
            {totalDebit === "" && (<span>&nbsp;</span>)}
            {totalDebit !== "" && (<CurrencyInput displayType="text" value={totalDebit} />)}
        </div>
    );

};

export const GridTitleItem = ( {className,} ) => {
    return (
        <div 
            className={classNames(className, "d-flex justify-content-end")} 
        >
        </div>
    );

};

export const StyledGridItem = styled(GridItem)`
    width: 100px;
    height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledGridTotalsItem = styled(GridTotalItem)`
    width: 100px;
    height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
`;

//export const StyledGridTitleItem = styled(GridTitleItem)`
    //width: 100px;
    //height: 25px;
    //overflow: hidden;
    //text-overflow: ellipsis;
    //margin-bottom: 0px;
    //color: #0d5fa6;
//`;

export const AgedDebtorsGridColumnLabel = styled(FormLabel)`
    width: 100px;
    height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
    color: #0d5fa6;
`;

export const AgedDebtorsGridColumnTitleLabel = styled(FormLabel)`
    width: 100px;
    height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
    color: #0d5fa6;
`;

//needed separate row for totals as when applied to main grid filtering messed up formatting on displayed Afged Debtor grid
export const AgedDebtorsGridColumnTotalsLabel = styled(FormLabel)`
    width: 100px;
    height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
    color: #0d5fa6;
`;

const AgedDebtorsLayoutGrid = styled(Main)`
    display: grid;
    grid-template-columns: 100px auto;
    grid-template-rows: auto auto;
    gap: 0px 0px;
    overflow-y: scroll;
    overflow-x: scroll;
    grid-template-areas:
    "grid-dates-header grid-dates-header  "
    "grid-dates-left grid-data "
    "grid-totals-left grid-totals-data ";
`;

const GridArea = styled.div`
    grid-area: ${props => props.gridArea};
`;

const AgedDebtorsTable = () => {
    const label="Aged Debtors";
    const { results, error, isClearing, isLoading, isError, retryGetAgedDebtors } = useGetAgedDebtors();
    const data = results;

    const [leftDates, setLeftDates] = useState([{}]);
    const [headerDates, setHeaderDates] = useState([{}]);
    const [monthTotals, setMonthTotals] = useState([{}]);
    //const { leftDates, setLeftDates, headerDates, setHeaderDates, monthTotals, setMonthTotals, agedDebtorFilterApplied, setAgedDebtorFilterApplied } = useAdministrationFeesProvider();


    const [selectedArchiveMonth, setSelectedArchiveMonth] = useState(null);
    const [selectedAgedMonth, setSelectedAgedMonth] = useState(null);
    const [selectedTotalDebt, setSelectedTotalDebt] = useState(null);
    const [archiveRequest, setArchiveRequest] = useState(null);

    const [detailedRequest, setDetailedRequest ] = useState(null);
    const [showModal, setShowModal ] = useState(false);

    const [showArchiveDebtorsModal, setShowArchiveDebtorsModal] = useState(false);

    const createArchiveRequest = (archiveMonth, loadFromMonth) =>{
            setArchiveRequest({archiveDate: moment(new Date(archiveMonth)).format("YYYY-MM-DD"),loadFromDate: moment(new Date(loadFromMonth)).format("YYYY-MM-DD")});
    };

    const { archiveDebtors } = useArchiveDebtors(archiveRequest);
    
    //for now at least - maybe set when page loaded / reloaded and uset to reload when
    //an archive is carried out
    //may not be needed?
    const [reloadDebtorsFromDate, setReloadDebtorsFromDate] = useState(moment(new Date("2023-06-01")).format("YYYY-MM-DD"));
    
    const updateModalData = (agedMonth,archiveMonth,debt, feeGroupIds) => {

        setDetailedRequest({
            archiveMonth: archiveMonth !== null ? moment(new Date(archiveMonth)).format('YYYY-MM-DD') : null, 
            agedMonth: (agedMonth !== null && agedMonth !== "Total") ? moment(new Date(agedMonth)).format('YYYY-MM-DD') : null,
            feeGroupIds: feeGroupIds !== null ? feeGroupIds : null
        });

        setSelectedTotalDebt(debt);
    }

    React.useEffect(() => {
        if(detailedRequest !== null && detailedRequest.agedMonth !== null && selectedTotalDebt !== 0 && selectedTotalDebt !== ''){
            //console.log("Refreshing Table:", detailedRequest);
            setShowModal(true);
        }
        else{
            setShowModal(false);
        }
    },[detailedRequest]);

    const transpose = (array) => {
        var transposedArray = [];
        //var arrayLength = array[0].length;
        var arrayLength = 13;
        for(var i = 0; i < array[0].length; i++){
            var newArray = [];
            for(var j=0; j < array.length; j++){
                newArray.push(array[j][i]);
            }
            transposedArray.push(newArray);
        };
        return transposedArray;
    };

    const columns = useMemo(() => {
        if (data.length < 1 ) {
            return [];
        }
        let retval = [];
        let theHeaderDates = [];
        let theLeftDates = [];
        let debtorsList = [];

        //in case there's a 'missing' month on foltering - as in testing
        //the missing month threw error and conditional render of grid affected formatting
        const tempArray = JSON.parse( JSON.stringify( data ) );
        var dataArray = [];
        dataArray.push(tempArray[0]);
        for(var j = 0; j < tempArray.length-1; j++){
            let currentMonth = tempArray[j].archiveMonth;
            let nextMonthInLine = moment(currentMonth).add(-1, 'M');
            let nextMonthInLineToCheck = moment(nextMonthInLine).endOf('month').format('YYYY-MM-DDT00:00:00');
            if(tempArray.filter(n => moment(n.archiveMonth).format('YYYY-MM-DDT00:00:00') === nextMonthInLineToCheck).length === 0){
                dataArray.push({archiveMonth:nextMonthInLineToCheck, agedDebtorsDateGroupedViewModelList:[{agedMonth:nextMonthInLineToCheck, archiveMonth:nextMonthInLineToCheck, feeGroupIds:[], totalDebit:0}]});
            }
            else{ 
                if(j!==0){
                    dataArray.push(tempArray[j]);
                }                 
            }
        }
        //push the last element we never checked for next month
        dataArray.push(tempArray[tempArray.length-1]);
        ////////////////////////////////
        ///get the archived months so we can stop adding a column for any that are not there - when creating earliest/latest??
        let archivedMonthsArray = [];

        //to get earliest and latest month to create grid to host all aged debtor columns returned form server//
        let monthArray = [];
        let totalsArray = [];

        for(var j=0; j < dataArray.length; j++){
            //console.log('archived months ', dataArray[j].archiveMonth);
            archivedMonthsArray.push(dataArray[j].archiveMonth);
            for(var i = 0; i < dataArray[j].agedDebtorsDateGroupedViewModelList.length; i++){
                monthArray.push(dataArray[j].agedDebtorsDateGroupedViewModelList[i].agedMonth);
            }
        }

        let earliestArray = [].concat(monthArray),
        earliest = earliestArray.reduce(function (pre, cur) {
            return Date.parse(pre) > Date.parse(cur) ? cur : pre;
        });

        let latestArray = [].concat(archivedMonthsArray),
        latest = latestArray.reduce(function (pre, cur) {
            return Date.parse(pre) < Date.parse(cur) ? cur : pre;
        });

        let tempLeftDates = [];
        let previousMonth = moment(latest).add(-0, 'M');
        let previousMonthToAdd = moment(previousMonth).endOf('month');
        tempLeftDates.push({date:previousMonthToAdd.format('YYYY-MM-DDT00:00:00'),month:previousMonthToAdd.format('MMM-YY')});
        while(!(moment(previousMonth).isBefore(moment(earliest)))){
            previousMonth = moment(previousMonth).add(-1, 'M');
            let previousMonthToAdd = moment(previousMonth).endOf('month');
            tempLeftDates.push({date:previousMonthToAdd.format('YYYY-MM-DDT00:00:00'),month:previousMonthToAdd.format('MMM-YY')});
        }

        var gridDataArray = JSON.parse( JSON.stringify( dataArray ) );
        //var gridDataArray = JSON.parse( JSON.stringify( data ) );
        var numToAdd = 0;
 
        tempLeftDates.forEach((obj) =>{
            for(var x=0;x<gridDataArray.length;x++){
                if(!gridDataArray[x].agedDebtorsDateGroupedViewModelList.some(d => d.agedMonth === obj.date)){
                    let archiveMonth = gridDataArray[x].agedDebtorsDateGroupedViewModelList[0].archiveMonth;
                    if(!(moment(obj.date).isAfter(moment(archiveMonth)))){
                        //console.log('archiveMonth',obj);
                        numToAdd++;
                        gridDataArray[x].agedDebtorsDateGroupedViewModelList.push({agedMonth: obj.date, archiveMonth: archiveMonth, totalDebit: 0 });
                    }        
                }
                //gridDataArray[x].ord
            }
        });
    
        var blankDebtors = 0;
        
        var blankDebtor={agedMonth: "1066-01-01T00:00:00", totalDebit: ''};
        
        setLeftDates(tempLeftDates);

        //above with new array rather than data
        const sortByAgedMonth = (a,b) => {
            return new Date(b.agedMonth) - new Date(a.agedMonth);
        }
        const sortByArchiveMonth = (a,b) => {
            return new Date(b.archiveMonth) - new Date(a.archiveMonth);
        }
        for (var i = 0; i <gridDataArray.length; i++) {
            gridDataArray[i].agedDebtorsDateGroupedViewModelList.sort(sortByAgedMonth);
            theHeaderDates.push({archiveMonth: gridDataArray[i].archiveMonth, headerDate: new Date(gridDataArray[i].archiveMonth).toLocaleDateString('en-uk')});
            //console.log('gridData[i] before pushing blanks ',gridDataArray[i]);
            var newArr = [];
            if(i > 0){
                for(var p=1;p<=blankDebtors;p++){
                    ////newArr.push(blankDebtor);
                    newArr.push({agedMonth: "1066-01-01T00:00:00", archiveMonth: gridDataArray[i].archiveMonth,  totalDebit: ""});
                }
            }
            let archMonthTotDebit = 0;
            
            for(var t = 0;t<gridDataArray[i].agedDebtorsDateGroupedViewModelList.length;t++ ){
                archMonthTotDebit += gridDataArray[i].agedDebtorsDateGroupedViewModelList[t].totalDebit;
            }
            totalsArray.push({archiveMonth:gridDataArray[i].archiveMonth, totalDebit:archMonthTotDebit});
            newArr.push(...gridDataArray[i].agedDebtorsDateGroupedViewModelList);
            debtorsList.push(newArr);
            
            retval.push({ archiveMonth: new Date(gridDataArray[i].archiveMonth).toLocaleDateString('en-uk'), archiveMonthDebtorAmount: gridDataArray[i].agedDebtorsDateGroupedViewModelList[0].totalDebit, agedDebtorList: gridDataArray[i].agedDebtorsDateGroupedViewModelList});
            for(var k = 0; k < gridDataArray[k].length; j++){
                //console.log(new Date(data[i][k].agedMonth).toLocaleDateString());
                ////console.log(data[i][k].totalDebit);
                //retval.push({ label: new Date(data[i][k].agedMonth).toLocaleDateString(), property: data[i][k].totalDebit });
            }
            blankDebtors++;
        }
        totalsArray.sort(sortByAgedMonth);

        setMonthTotals(totalsArray);

        setHeaderDates(theHeaderDates);

        var transposed = transpose(debtorsList);
        return transposed;
    }, [ data ]);

    
    if (isLoading) {
        return (
            <div>
                LOADING THE DATA...
            </div>
        );
    }
    if (isError) {
        return <ErrorMessageWrapper>
            <ErrorMessage error={error} retryCallback={retryGetAgedDebtors} />
        </ErrorMessageWrapper>;
    }

    return (
        <React.Fragment>
        <Main className="d-flex flex-column">
            <AgedDebtorsAgedMonthBreakdownModal
                show={showModal}
                onHide={() => {
                    setDetailedRequest(null);
                    setSelectedTotalDebt(null);
                    setShowModal(false);
                }}
                detailedRequest={detailedRequest}
            />
            <ArchiveDebtorsModal
                show={showArchiveDebtorsModal}
                handleArchiveDebtorsModalClose={() => {
                    setShowArchiveDebtorsModal(false);
                }}
                reloadDebtorsFromDate={reloadDebtorsFromDate}
            />
        <AgedDebtorsLayoutGrid>
            <GridArea gridArea="grid-dates-header" className="d-flex flex-nowrap justify-content-left align-items-center overflow-hidden">
                <AgedDebtorsGridColumnTitleLabel className="d-flex flex-nowrap justify-content-left align-items-right overflow-hidden fw-bold"><span>Debt</span></AgedDebtorsGridColumnTitleLabel>             
                {(columns.length > 1) ? (headerDates.map((el, _i) => <AgedDebtorsGridColumnLabel key={el.archiveMonth} className="text-center border">{el.headerDate}</AgedDebtorsGridColumnLabel>)) :null}
            </GridArea>
            <GridArea gridArea="grid-dates-left" className="d-flex flex-column overflow-hidden">
                {(columns.length > 1) ? (leftDates.map((el, _i) => <AgedDebtorsGridColumnLabel key={el.date} className="">{el.month}</AgedDebtorsGridColumnLabel>)) : null}

            </GridArea>
            <GridArea gridArea="grid-data">
                {(columns.length > 1) ? (columns.map(((d, i) => (
                    <div key={i} className="d-flex flex-nowrap justify-content-left align-items-center overflow-hidden">
                        {d.map((el, _i) => ((typeof(el) != "undefined") ? 
                            (<StyledGridItem key={el.archiveMonth} data={el} openModal={(e) => updateModalData(e.agedMonth, e.archiveMonth, e.totalDebit, e.feeGroupIds)} className={`${el.agedMonth === "Total" ? 'd-flex flex-nowrap justify-content-left align-items-center overflow-hidden fw-bold' : 'd-flex flex-nowrap justify-content-left align-items-center overflow-hidden'}`} />) : null
                            //<StyledGridItem key={el.agedMonth} data={el} openModal={(e) => console.log('agedMonth',e.agedMonth, 'archiveMonth',e.archiveMonth)} />
                        ))}
                    </div>   
                )))) : null}
            </GridArea>
            <GridArea gridArea="grid-totals-left">
                <AgedDebtorsGridColumnTotalsLabel><span className= 'd-flex flex-nowrap justify-content-left align-items-center overflow-hidden fw-bold'></span>Totals</AgedDebtorsGridColumnTotalsLabel>
            </GridArea>
            <GridArea gridArea="grid-totals-data">
                <div key="monthTotals" className="d-flex flex-nowrap justify-content-left align-items-center overflow-hidden">
                    {(columns.length > 1) ? (monthTotals.map((el, _i) => <StyledGridTotalsItem key={el.archiveMonth} data={el} className="d-flex flex-nowrap justify-content-left align-items-right overflow-hidden fw-bold"></StyledGridTotalsItem>)) : (<StyledGridTotalsItem data={0} className="d-flex flex-nowrap justify-content-left align-items-right overflow-hidden fw-bold"></StyledGridTotalsItem>)}  
                </div>
            </GridArea>
        </AgedDebtorsLayoutGrid>     
        </Main>
        </React.Fragment>
    );
};
export default AgedDebtorsTable;

